import React from 'react';
import ImageComponent from 'atoms/Image/index';
import { Row } from 'react-bootstrap';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';
import ContactKFCForm from '../AU/ContactKFCForm';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { useSelector } from 'react-redux';

export const getContactUsIframe = contactUsContent => {
  const hostUrl = contactUsContent?.items?.[0]?.fields?.body?.[1]?.fields?.hostUrl ?? {};
  const I_FRAME = `<iframe src="${hostUrl}" onload='(function(o){o.style.height=o.contentWindow.document.body.scrollHeight+"px";}(this));' style="height:100vh;width:100%;border:none;overflow:hidden;"></iframe>`;
  const iframe = () => {
    return {
      __html: I_FRAME,
    };
  };
  return (
    <div>
      <div className='hostedContentFrame' dangerouslySetInnerHTML={iframe()} />
    </div>
  );
};

export const getContactRightSection = ({
  isMobile,
  history,
  tenantId,
  bodyFormData,
  headerFormData,
  isRenderIframeinContactUs,
  contactUsContent,
}) => {
  return (
    <div className={(isMobile && 'contactUs-section-body') || 'contactKFC-section-right'}>
      <div className={!isMobile && 'contactUs-description-desktop'}>
        {isRenderIframeinContactUs ? (
          getContactUsIframe(contactUsContent)
        ) : (
          <>
            <div className={(isMobile && 'border-style-touch-mobile') || ' border-style-touch'}>
              <div className={(isMobile && 'display-none') || 'touch-title'}>
                {translateWithI18Next(TRANSLATE_MAPPING_KEY.GET_TOUCH)}
              </div>
              <ContactKFCForm bodyFormData={bodyFormData} history={history} isMobile={isMobile} tenantId={tenantId} />
            </div>
            <div className={(isMobile && 'contactus-body-description-end ') || 'contactus-body-description'}>
              {headerFormData?.disclaimerSection}
              <a href={headerFormData?.hyperLinkSection} className='hyperLinkSection-KFC'>
                {headerFormData?.hyperLinkTitle ?? headerFormData?.hyperLinkSection}
              </a>
              )
            </div>
          </>
        )}
      </div>
    </div>
  );
};
const ContactKFCView = props => {
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { componentOptions: { web: { contactKFC: { isRenderIframeinContactUs } = {} } = {} } = {} } =
    tenantReducer ?? {};
  const { userOrderState, headerFormData, bodyFormData, isMobile, history, tenantId } = props;
  const contactUsContent = useSelector(data => data?.contactUsReducer?.response?.contactUsResp);

  return (
    <div className={isMobile ? 'contactUs-mobile-container' : 'contactUs-desktop-container'}>
      <div className={isMobile ? 'contactUs-mobile-header' : 'contactUs-section-left'}>
        <Row className='faq-stripes-section'>
          <ImageComponent srcFile={headerFormData?.desktopImage} className='stripes-img' />
        </Row>
        <h1 className='contactus-header-title'>{headerFormData?.headLine}</h1>
        <div className='contactus-header-description'>{headerFormData?.descriptionLine}</div>
      </div>
      {getContactRightSection({
        isMobile,
        history,
        tenantId,
        bodyFormData,
        headerFormData,
        isRenderIframeinContactUs,
        contactUsContent,
      })}
      {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
    </div>
  );
};
export default ContactKFCView;
